import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export const AdjustmentDialog = ({ open, onClose, adjForm, setAdjForm, onSave }) => (
  <Dialog open={open} onOpenChange={onClose}>
    <DialogContent data-testid="supplier-adjustment-dialog" className="max-w-sm">
      <DialogHeader>
        <DialogTitle>Ledger Adjustment</DialogTitle>
        <DialogDescription>Positive amount increases what you owe (debit); negative reduces it (credit) — e.g. a rate correction or discount.</DialogDescription>
      </DialogHeader>
      <div className="space-y-3">
        <div>
          <Label className="text-xs">Ledger</Label>
          <Select value={adjForm.kind} onValueChange={(v) => setAdjForm({ ...adjForm, kind: v })}>
            <SelectTrigger data-testid="adjustment-kind-select" className="mt-1"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="inr">Rupee (₹)</SelectItem><SelectItem value="gold">Gold (fine g)</SelectItem></SelectContent>
          </Select>
        </div>
        <div><Label className="text-xs">Amount {adjForm.kind === "gold" ? "(fine g)" : "(₹)"}</Label><Input type="number" value={adjForm.amount} onChange={(e) => setAdjForm({ ...adjForm, amount: e.target.value })} className="mt-1 font-mono" placeholder="e.g. -500 for a credit" /></div>
        <div><Label className="text-xs">Note</Label><Input value={adjForm.note} onChange={(e) => setAdjForm({ ...adjForm, note: e.target.value })} className="mt-1" placeholder="Reason for adjustment" /></div>
      </div>
      <DialogFooter><Button variant="outline" onClick={onClose}>Cancel</Button><Button onClick={onSave}>Save Adjustment</Button></DialogFooter>
    </DialogContent>
  </Dialog>
);
